define([
	"dojo/_base/declare",
	"csi/form/Widget",
	"csi/xml"
], function(declare, Widget, xml) {

	return declare(Widget, {

		_resolveView: function() {
			var inspectionURL = this.getFormNode().__Parent__;
			var inspection = this.getCache().get(inspectionURL);
			if (inspection) {
				var batchNumber = inspection.Batches.length + 1;
				this.addDefaultValue(xml.ATTR_NAME, "Batch " + batchNumber);
				this.addDefaultValue("SamplingPlan", inspection.SamplingPlan);
			}

			this.inherited(arguments);
		}

	});
});